import { useEffect } from 'react';
import { noop } from "../../utils/noop";
/**
 * Set aria-hidden={true} on all non overlayed elements for
 * accessibility. This is used when a Dialog is open.
 */

export function useHideBody(rootRef) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  useEffect(function () {
    var originalValues = [];
    var rootNodes = [];

    if (enabled) {
      Array.prototype.forEach.call(document.querySelectorAll('body > *'), function (node) {
        if (node === rootRef.current) {
          return;
        }

        var attr = node.getAttribute('aria-hidden');
        var alreadyHidden = attr !== null;

        if (alreadyHidden) {
          return;
        }

        originalValues.push(attr);
        rootNodes.push(node);
        node.setAttribute('aria-hidden', 'true');
      });
      return function () {
        rootNodes.forEach(function (node, index) {
          var originalValue = originalValues[index];

          if (originalValue === null) {
            node.removeAttribute('aria-hidden');
          } else {
            node.setAttribute('aria-hidden', originalValue);
          }
        });
      };
    }

    return noop;
  }, [rootRef, enabled]);
}